import React from 'react';
import { Columns } from '../../components/Columns';
import { Row } from '../../components/Columns/Row';
import { Column } from '../../components/Columns/Column';
import { classNames } from '../../utils/style';
import {
  fontBody,
  fontHeading2,
  fontHeading3,
  fontMegaBody,
} from '../../styles/typographyNew';

export type FeaturesListSectionProps = {
  title: string;
  description: string;
  rows: any[];
};


export const FeaturesListSection = ({ title, description, rows }: any) => {
  return (
    <div className={classNames('FeaturesListSection')}>
      <div className={classNames('FeaturesListSectionHeader m-auto')}>
        {title && (
          <h2 className={classNames(fontHeading2, 'text-center text-[#042040]')}>{title}</h2>
        )}
        {description && (
          <p
            className={classNames(
              fontMegaBody,
              'text-[#364A61] text-center max-w-[667px] m-auto',
              title && 'mt-20',
            )}
          >
            {description}
          </p>
        )}
      </div>
      <Columns className="w-full mt-80 items-stretch">
        {rows?.map((row: any, index: number) => (
          <Row key={index} template={row?.template}>
            {row?.content?.map((item, subIndex) => (
              <Column
                key={subIndex}
                className={classNames(
                  'bg-[#F7F9FC] rounded-[24px] text-[#042040]',
                  'flex flex-col justify-between',
                )}
              >
                <div
                  className={classNames(
                    'FeatureListContent',
                    'p-[32px] md:p-[42px]',
                  )}
                >
                  <h3 className={classNames(fontHeading3, 'mb-12')}>
                    {item?.title}
                  </h3>
                  <p className={classNames(fontBody, 'text-[#364A61]')}>
                    {item?.description}
                  </p>
                </div>
                {item?.image && item?.image}
              </Column>
            ))}
          </Row>
        ))}
      </Columns>
    </div>
  );
};
